import { COMPANY_DATA } from "../constants/action-types";

export const uploadCompaniesData = (results) => ({
    type: COMPANY_DATA.UPLOAD.START,
    payload: { url: "/api/v3.0/vetl/company-data/upload", body: JSON.stringify(results) },
});

export const startCompanyDataUploadJobPolling = (payload) => ({ type: COMPANY_DATA.JOB.POLL.START, payload });

export const fetchCompanyDataUploadJob = (jobId: string, pipelineId: string) => ({
    type: COMPANY_DATA.JOB.FETCH.START,
    payload: { url: "/api/v3.0/vetl/job", body: { jobId, pipelineId } },
});

export const resetUploadJob = () => ({ type: COMPANY_DATA.JOB.RESET });
